import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Message } from '@bijie/react-bnb';

import { setPostBody } from '../../../actions/actionsFactory';
import { gwPost } from '../../../actions/actionsFactory/gwRequest';
import API_PATH from '../../../actions/actionsFactory/apiPath';

import dateFormatter from '../../../utils/dateFormatter';

import VmTable from './VmTable';

const {
  object, string, bool, func,
} = PropTypes;

const BnbRecord = ({
  isLoggedIn, language, checkLogin, projectId,
}) => {
  const [
    { data }, setRecord,
  ] = useState({ loading: true, data: {} });

  const {
    title, trList, extTipPre, extTipAvg, preLogin, goLogin,
  } = language;

  const fetchData = async () => {
    if (isLoggedIn && projectId) {
      try {
        const { success, data: result, message } = await gwPost(
          API_PATH.VOTE2_LOG_BNB, { ...setPostBody({ projectId }) }
        );
        if (!success) throw new Error(message);
        setRecord({ loading: false, data: result });
      } catch ({ message }) {
        message && Message.fail(message);
        setRecord({ loading: false, data: [], error: true });
      }
    }
  };

  useEffect(() => { fetchData(); }, [isLoggedIn, projectId]);

  const { avgHold, items } = data || {};

  const extra = isLoggedIn && false ? <a>{extTipPre}</a> : null;
  const desc = isLoggedIn ? (
    <span className="desc">{extTipAvg}<b>{`${avgHold || 0} BNB`}</b></span>
  ) : <span className="desc" />;

  const tableBody = isLoggedIn ? (items || []).map((item, key) => (
    <div className="vm-table-tr" key={key}>
      <span style={{ flex: 'none' }}>
        {dateFormatter(new Date(item.date))}
      </span>
      <span>{item.bnb || 0}</span>
    </div>
  )) : [];

  const { length: isEmpty } = tableBody;

  return (
    <VmTable title={title} extra={extra} trList={trList} desc={desc}>
      { isEmpty ? (
        <div className="vm-table-body">{tableBody}</div>
      ) : (
        <div className="pre-login">
          <i className="no-icon" />
          { isLoggedIn ? <p /> : (
            <p>{preLogin}<a onClick={checkLogin}>{goLogin}</a></p>
          ) }
        </div>
      )}
    </VmTable>
  );
};

BnbRecord.propTypes = {
  projectId: string,
  i18n: object,
  language: object,
  locale: string,
  isLoggedIn: bool,
  checkLogin: func,
};

export default React.memo(BnbRecord);
